import { InjectionToken, Provider } from '@angular/core';
import { Article, ArticleSearch, ProductArticles } from '@article/const';
import { ActionReducerMap } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { ARTICLE, ARTICLES_SEARCH, ArticleState, PRODUCT_ARTICLES } from '../article-state';

export type ArticleReducers = ArticleState;

export function getReducers(): ActionReducerMap<ArticleReducers> {
  return {
    articlesSearch: StateUtils.loaderReducer<ArticleSearch>(ARTICLES_SEARCH),
    article: StateUtils.entityLoaderReducer<Article>(ARTICLE),
    productArticles: StateUtils.entityLoaderReducer<ProductArticles>(PRODUCT_ARTICLES),
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<ArticleReducers>> = new InjectionToken<
  ActionReducerMap<ArticleReducers>
>('ArticleReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
